<svelte:options accessors/>
<script lang="ts">
    import type {IAddress, IProfileData} from "../../interfaces";
    import AddressList from "../address/AddressList.svelte";
    import Agenda from "./Agenda.svelte";
    import Subtotal from "./Subtotal.svelte";
    import {createEventDispatcher, onMount} from "svelte";
    import {Cart, getCart} from "../../models/cart";
    import DispatchSection from "./dispatch/DispatchSection.svelte";
    import LinearProgress from "@smui/linear-progress";
    import DispatchServiceSection from "./dispatch/DispatchServiceSection.svelte";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import Snackbar, {Label} from "@smui/snackbar";
    import IconButton from "@smui/icon-button";

    const dispatch = createEventDispatcher();
    let meetingCmpt: any
    export let addresses: Array<IAddress>;
    export let cities: Array<any>;
    export let departments: Array<any>;
    export let hours: any;

    export let email: string;
    export let loading: boolean = true;
    export let dialog: any = {
        open: false,
        message: ''
    }

    export let profile: IProfileData;
    let cart: Cart;
    let validated: boolean;
    let snackbarCmpt;

    onMount(() => {
        getCart().then((c) => {
            cart = c;
            loading = false;
        });
    });

    async function next() {
        if (valid()) {
            try {
                cart.dispatch = value();
                const {error, messages} = await cart.checkPrices();
                validated = !error;
                if (validated) {
                    await cart.update();
                    dispatch('next');
                } else {
                    let element = '<div>';
                    element += '<ul>'
                    messages.forEach((message: string) => {
                        element += `<li>${message}</li>`
                    })
                    element += '</ul>'
                    element += '</div>'
                    dialog.message = element;
                    dialog.open = true;
                }
            } catch (e) {

            }
        }
    }

    function valid(): boolean {
        const options = [];
        if (cart.toDelivery) {
            options.push(!!addresses.find(a => a.selected))
        }
        if (cart.needSchedule) {
            options.push(!!meetingCmpt && !!meetingCmpt.valid())
        }
        return options.every(o => !!o);
    }

    function value(): any {
        return {
            address: addresses.find(a => a.selected),
            schedule: !!meetingCmpt ? meetingCmpt.value : undefined
        }
    }

    function closeDialog() {
        dialog.open = false;
        dialog.message = '';
    }

    function login() {
        if (email) {
            dispatch('logIn', {
                email
            })
        }
    }
</script>
<div>
    {#if loading}
        <div class="text-c mt-2 px-1">
            <LinearProgress class="w-100" indeterminate/>
            <small>Cargando...</small>
        </div>
    {:else if profile && cart}
        {#if cart.toDelivery}
            <section>
                <div class="container max-w-900px mx-auto">
                    <DispatchSection title="Productos de envío a domicilio"
                                     items={cart.partsWithDelivery}/>
                    <DispatchSection title="Accesorios de envío a domicilio"
                                     items={cart.accessoriesToDelivery}/>
                </div>
            </section>
            <AddressList data="{addresses}"
                         {departments}
                         enableSelect="{true}"
                         on:upsert/>
            <hr>
        {/if}
        {#if cart.partsWithoutDelivery}
            <section>
                <div class="container max-w-900px mx-auto">
                    <DispatchSection title="Items sin envío a domicilio"
                                     items={cart.partsWithoutDelivery}/>
                </div>
            </section>
        {/if}
        {#if cart.toSchedule}
            <section>
                <div class="container max-w-900px mx-auto">
                    <DispatchSection title="Accesorios"
                                     items={cart.accessoriesToInstall}/>
                    <DispatchServiceSection title="Servicios"
                                            items={cart.services}/>
                    <DispatchServiceSection title="Revisiones"
                                            items={cart.revisions}/>
                </div>
            </section>
            <Agenda bind:this={meetingCmpt} {cities}
                    {hours}
                    on:queryHours/>
            <hr>
        {/if}
        {#if cart.plans?.length > 0}
            <section>
                <div class="container max-w-900px mx-auto">
                    <DispatchServiceSection title="Planes"
                                            items={cart.plans}/>
                </div>
            </section>
        {/if}
        <Subtotal subtotal="{cart.subtotal}"
                  on:click={()=>next()}/>
    {:else}
        <section class="py-2">
            <div class="container max-w-900px mx-auto">
                <h2 class="mb-2">Ingresa tu correo electrónico para continuar con tu compra</h2>
                <div class="mb-3">
                    <input name="email" class="naui-input" type="email" bind:value={email}
                           placeholder="Correo electrónico (*)">
                    <div class="box mt-2">
                        <div on:click={()=>login()}
                             class="btn accent disabled text-c min-w-200px"
                             class:disabled={!email}>
                            CONTINUAR
                        </div>
                    </div>
                    <div class="m-2">
                        <b>Guardamos tu correo electrónico para:</b>
                        <ul>
                            <li>Guardar tu historial de compra.</li>
                            <li>Informarte sobre tu pedido.</li>
                            <li>Identificarte como usuario de la tienda.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    {/if}
</div>

<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {@html dialog.message}
    </Content>
    <Actions>
        <div class="box sx-ii">
            <NauiButton caption="ACEPTAR"
                        color="accent"
                        mode="solid"
                        on:click={()=>closeDialog()}/>
        </div>
    </Actions>
</Dialog>

<Snackbar bind:this={snackbarCmpt}>
    <Label>Datos incompletos o invalidos.</Label>
    <Actions>
        <IconButton class="material-icons" title="Dismiss" on:click={()=>snackbarCmpt.close()}>close</IconButton>
    </Actions>
</Snackbar>